import React, { useContext, useState } from 'react';
import Sort, { BLUR_TARGET } from './sort';
import { ListerContext } from '../../listerContext';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';
import getPressedKey, { KeyboardMap } from '../../../../helpers/getPressedKey';
import { ListerSortData } from '../../../../types';
import useListerApi from '../../listerApiHooks';

function SortContainer(): React.ReactElement {
  const [formattedMessage] = useContext(MessagePropertiesContext);
  const [{ isListerDisabled, sorts }] = useContext(ListerContext);
  const [selectedOption, setSelectedOption] = useState(sorts.find((s) => s.selected)?.code || '');
  const [focusedOption, setFocusedOption] = useState<string>('');
  const [isOpen, setIsOpen] = useState(false);
  const { selectSort } = useListerApi();

  const toggleOpen = (): void => {
    setIsOpen((open) => !open);
  };

  const handleEsc = (e: React.KeyboardEvent): void => {
    if (getPressedKey(e) === KeyboardMap.ESCAPE) {
      e.preventDefault();
      setIsOpen(false);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLButtonElement>): void => {
    const insideList = (e.relatedTarget as HTMLElement)?.dataset.blur === BLUR_TARGET;
    if (!insideList) {
      setIsOpen(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    setIsOpen(false);
    setSelectedOption(e.target.value);
    selectSort(e.target.value);
  };

  const handleOptionClick = (option: ListerSortData): void => {
    setIsOpen(false);
    setSelectedOption(option.code);
    selectSort(option.code);
  };

  return (
    <Sort
      toggleOpen={toggleOpen}
      handleBlur={handleBlur}
      handleFocus={setFocusedOption}
      handleChange={handleChange}
      handleEsc={handleEsc}
      handleOptionClick={handleOptionClick}
      isOpen={isOpen}
      selectedOption={selectedOption}
      focusedOption={focusedOption}
      sortOptions={sorts}
      isDisabled={isListerDisabled}
      messages={{
        sortTitle: formattedMessage({ id: 'search.nav.sort.title', fallback: 'Sort' }),
        sortByTitle: formattedMessage({ id: 'search.nav.sortBy.title', fallback: 'Sort by:' })
      }}
    />
  );
}

export default SortContainer;
